import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const HeaderWrapper = styled.div`
  .avatarContainer {
    padding: 0 10px;
  }
  .main-div {
    padding: 2rem 1rem 1rem;
    .layout-direction {
      display: flex;
      justify-content: end;
      align-items: center;
      .blank-box {
        flex-grow: 1;
      }
      .white-box {
        background: #ffffff;
        width: 45px;
        height: 45px;
        line-height: 42px;
        margin-right: 15px;
        border-radius: 50%;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
        user-select: none;

        .success-icon {
          background: #13a10e;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: absolute;
          right: 4px;
        }
      }
      .help-button {
        background: ${colors["bright-purple"]};
        border: 1px solid ${colors["bright-purple"]};
        border-radius: 100px;
        height: 45px;

        font-size: 0.9rem;
        padding: 0px 25px;
        box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
        color: #fff;
        .pi-info-circle {
          margin-right: 10px;
        }
      }

      .help-button-bsf {
        background: var(--color-green-bsf);
        border: 1px solid var(--color-green-bsf);
      }
      .help-button-stc {
        background: var(--color-purple-stc);
        border: 1px solid var(--color-purple-stc);
      }
      .help-button-lucid {
        background: var(--color-black-lucid);
        border: 1px solid var(--color-black-lucid);
      }
      .help-button-cartrust {
        background: var(--color-primary-cartrust);
        border: 1px solid var(--color-primary-cartrust);
      }
      .help-button-syarah {
        background: var(--color-primary-syarah);
        border: 1px solid var(--color-primary-syarah);
      }
      .help-button-snb {
        background: var(--color-green-snb);
        border: 1px solid var(--color-green-snb);
      }
      .help-button-alnaghi {
        background: var(--color-alnaghi);
        border: 1px solid var(--color-alnaghi);
      }
      .help-button-petromin {
        background: var(--color-primary-petromin);
        border: 1px solid var(--color-primary-petromin);
      }
    }
  }
  .ml-15 {
    margin-left: 15px;
  }
  @media only screen and (max-width: 992px) {
    .main-div {
      padding: 0 !important;
    }
  }
`;

export default HeaderWrapper;
